import React, {useState, Fragment, ReactNode} from 'react';




// props the component accepts: 
/*
    image: SRC string
    child: Can be any element (i.e. <h1> or another component)
*/
 

function CardWithImage(props: {
    image?: string;
    children?: ReactNode | ReactNode[];
}) {

    return <>
            <div className="listing-choice w-full h-full p-6 max-w-sm bg-white rounded-lg border border-gray-200 shadow-sm hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    <img className="container-image w-80 h-64 rounded-lg mb-4" src={`${props.image}`} />
                <div className="cta-button grid w-full  ml-2 place-content-center">
                    {props.children}
                </div>
            </div> 
    </>
}
export default CardWithImage;